var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4EA7\\u54C1\\u5168\\u666F\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8080051,5.36491568 C15.0716283,2.28763184 12.3029667,0 9,0 C6.57972979,0 4.44634509,1.22830284 3.18921171,3.09554267 M2.13702572,8.3851397 C2.58051472,10.5945935 4.06425828,12.4279275 6.05559386,13.3524789 C6.95063966,13.7680371 7.94823091,14 9,14 C11.5632142,14 13.8046546,12.6223225 15.0242405,10.5670483",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4163086,2.45494143 L14.4163086,4.95494143 L14.4163086,4.95494143 L16.9163086,4.95494143 C17.1924509,4.95494143 17.4163086,5.17879906 17.4163086,5.45494143 C17.4163086,5.73108381 17.1924509,5.95494143 16.9163086,5.95494143 L13.9163086,5.95494143 C13.6401662,5.95494143 13.4163086,5.73108381 13.4163086,5.45494143 L13.4163086,2.45494143 C13.4163086,2.17879906 13.6401662,1.95494143 13.9163086,1.95494143 C14.1924509,1.95494143 14.4163086,2.17879906 14.4163086,2.45494143 Z",
    fill: "currentColor",
    transform: "translate(15.416309, 3.954941) rotate(-60.000000) translate(-15.416309, -3.954941) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.63313697,8.13886058 L1.63313697,10.6388606 L1.63313697,10.6388606 L4.13313697,10.6388606 C4.40927935,10.6388606 4.63313697,10.8627182 4.63313697,11.1388606 C4.63313697,11.415003 4.40927935,11.6388606 4.13313697,11.6388606 L1.13313697,11.6388606 C0.856994597,11.6388606 0.633136972,11.415003 0.633136972,11.1388606 L0.633136972,8.13886058 C0.633136972,7.86271821 0.856994597,7.63886058 1.13313697,7.63886058 C1.40927935,7.63886058 1.63313697,7.86271821 1.63313697,8.13886058 Z",
    fill: "currentColor",
    transform: "translate(2.633137, 9.638861) scale(-1, -1) rotate(-70.000000) translate(-2.633137, -9.638861) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycle);
export default __webpack_public_path__ + "static/media/recycle.37dd1103.svg";
export { ForwardRef as ReactComponent };